const state = {
  crypto: {
    oxapay: {
      supportedCurrencies: {}
    }
  }
}

const getters = {
  settings: state => state
}

const mutations = {
  settings_set_crypto(state, crypto) {
    state.crypto = crypto
  }
}

export default {
  state,
  getters,
  mutations
}
